module.exports = __webpack_public_path__ + "img/content_app-bonusscheck.9c0303f3.svg";